export default __webpack_public_path__ + "static/media/2_0106.e2507286.webp";